/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Step_Create_Resume_DescInputs */

const en_dashboard_step_create_resume_desc = /** @type {(inputs: Dashboard_Step_Create_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload or build your first resume`)
};

const de_dashboard_step_create_resume_desc = /** @type {(inputs: Dashboard_Step_Create_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade deinen ersten Lebenslauf hoch oder erstelle ihn`)
};

const fr_dashboard_step_create_resume_desc = /** @type {(inputs: Dashboard_Step_Create_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharge ou crée ton premier CV`)
};

const es_dashboard_step_create_resume_desc = /** @type {(inputs: Dashboard_Step_Create_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suba o cree su primer currículum`)
};

const it_dashboard_step_create_resume_desc = /** @type {(inputs: Dashboard_Step_Create_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica o costruisci il tuo primo curriculum vitae`)
};

const nl_dashboard_step_create_resume_desc = /** @type {(inputs: Dashboard_Step_Create_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload of bouw je eerste cv`)
};

const pl_dashboard_step_create_resume_desc = /** @type {(inputs: Dashboard_Step_Create_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wgraj lub zbuduj swoje pierwsze CV`)
};

const fi_dashboard_step_create_resume_desc = /** @type {(inputs: Dashboard_Step_Create_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa tai luo ensimmäinen ansiotodistuksesi`)
};

const da_dashboard_step_create_resume_desc = /** @type {(inputs: Dashboard_Step_Create_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload eller opret dit første CV`)
};

const sv_dashboard_step_create_resume_desc = /** @type {(inputs: Dashboard_Step_Create_Resume_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda upp eller bygg ditt första CV`)
};

/**
* | output |
* | --- |
* | "Upload or build your first resume" |
*
* @param {Dashboard_Step_Create_Resume_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_step_create_resume_desc = /** @type {((inputs?: Dashboard_Step_Create_Resume_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Step_Create_Resume_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_step_create_resume_desc(inputs)
	if (locale === "fr") return fr_dashboard_step_create_resume_desc(inputs)
	if (locale === "es") return es_dashboard_step_create_resume_desc(inputs)
	if (locale === "it") return it_dashboard_step_create_resume_desc(inputs)
	if (locale === "nl") return nl_dashboard_step_create_resume_desc(inputs)
	if (locale === "pl") return pl_dashboard_step_create_resume_desc(inputs)
	if (locale === "fi") return fi_dashboard_step_create_resume_desc(inputs)
	if (locale === "da") return da_dashboard_step_create_resume_desc(inputs)
	if (locale === "sv") return sv_dashboard_step_create_resume_desc(inputs)
	return en_dashboard_step_create_resume_desc(inputs)
});